import './PasswordResetPage.scss';

import { createContext, useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PasswordResetFinish from './PasswordResetSteps/PasswordResetFinish';
import PasswordResetStart from './PasswordResetSteps/PasswordResetStart';
import PasswordResetVerify from './PasswordResetSteps/PasswordResetVerify';

export const RESET_PASSWORD_STEPS = {
  START: 1,
  VERIFY: 2,
  FINISH: 3
}

/**
 * @typedef {Object} PasswordResetContext
 * 
 * @property {number} step
 * @property {React.Dispatch<React.SetStateAction<number>>} setStep
 */

/** @type {React.Context<PasswordResetContext>} */
const Context = createContext({});

export function usePasswordResetContext() {
  return useContext(Context);
}

export default function PasswordResetPage() {
  const [searchParams] = useSearchParams();
  const [step, setStep] = useState(RESET_PASSWORD_STEPS.START);

  useEffect(() => {
    if (step === RESET_PASSWORD_STEPS.START && searchParams.has('em') && searchParams.has('cd')) {
      setStep(RESET_PASSWORD_STEPS.FINISH);
    }
  }, [searchParams, step, setStep]);

  useEffect(() => {
    document.title = 'Reset Password - Papaya';
  }, []);

  return (
    <Context.Provider value={{ step, setStep }}>
      { step === RESET_PASSWORD_STEPS.START && (
        <PasswordResetStart />
      ) }
      { step === RESET_PASSWORD_STEPS.VERIFY && (
        <PasswordResetVerify />
      ) }
      { step === RESET_PASSWORD_STEPS.FINISH && (
        <PasswordResetFinish />
      ) }
    </Context.Provider>
  );
}
